import angular from 'angular';
import indexMetricsTabContent from './index-metrics-tab-content.component';

export default angular.module('eshq.indexMetricsTabContent', [])
  .component('eshqIndexMetricsTabContent', indexMetricsTabContent)
  .name;



// WEBPACK FOOTER //
// ./ui/src/components/index-metrics-tab-content/index-metrics-tab-content.js